import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchAppliedLeaves = createAsyncThunk(
  "appliedLeave/fetchAppliedLeaves",
  async (_, thunkAPI) => {
    try {
      const response = await axios.post(
        `${server}/appplied_leave_getall_and_by_date`,
        {},
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );

      const responseData = response.data?.["body-json"]?.body?.data;

      if (Array.isArray(responseData)) {
        return responseData.reverse();
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching applied leaves:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const appliedLeaveSlice = createSlice({
  name: "appliedLeave",
  initialState: {
    data: [],
    loading: true,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppliedLeaves.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchAppliedLeaves.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchAppliedLeaves.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default appliedLeaveSlice.reducer;
